import md5 from 'md5';

const colors = ['#3f4b83', '#7c80a0', '#a0a2a3', '#6c6f70', '#9fc97c', '#83bc3f', '#77b800', '#f3a17c', '#f18640', '#f07b05', '#173777', '#3f4b83'];

const hashString = (str: string) => {
    return md5(str);
};

export const getColorForUserInfo = (str: string) => {
    const hash = hashString(str);
    const hashNumber = parseInt(hash.slice(0, 8), 16);
    const colorIndex = hashNumber % colors.length;
    return colors[colorIndex];
};
